import { useContext, useMemo, createContext } from 'react';
import { bool, string, number, func, shape } from 'prop-types';
import { VARIATION_TYPE } from '../ChooseVariation/constants';

export const ChooseVariationContext = createContext({});

export const useChooseVariationContext = () => {
    const {
        brandName,
        userId,
        slogan,
        selectedVariationId,
        setSelectedVariationId,
        projectId,
        briefId,
        isProjectOwner,
        variations,
        hasFreeVariations,
    } = useContext(ChooseVariationContext);

    const selectedVariation = useMemo(
        () => variations.find(({ id }) => id === selectedVariationId),
        [variations, selectedVariationId]
    );
    const draftVariations = useMemo(() => variations.filter(({ type }) => type === VARIATION_TYPE.DRAFT), [variations]);
    const orderedVariations = useMemo(
        () => variations.filter(({ type }) => type === VARIATION_TYPE.ORDERED),
        [variations]
    );
    const suggestedVariations = useMemo(
        () => variations.filter(({ type }) => type === VARIATION_TYPE.SUGGESTED),
        [variations]
    );

    const selectedVariationPosition = useMemo(
        () => variations.findIndex(({ id }) => id === selectedVariationId),
        [variations, selectedVariationId]
    );

    return {
        brandName,
        userId,
        slogan,
        projectId,
        briefId,
        isProjectOwner,
        selectedVariation,
        selectedVariationPosition,
        setSelectedVariationId,
        variations,
        draftVariations,
        orderedVariations,
        suggestedVariations,
        hasFreeVariations,
    };
};

useChooseVariationContext.propTypes = {
    isProjectOwner: bool,
    brandName: string,
    userId: number,
    slogan: string,
    selectedVariation: string,
    setSelectedVariation: func,
    projectId: string,
    briefId: string,
    triggeredAction: shape({
        action: string,
        variationId: string,
        startTime: number,
        isWaiting: bool,
        isRunning: bool,
    }),
    setTriggeredAction: func,
    hasFreeVariations: bool,
};
